import { LanguageMetadata, TestMetadata } from 'api/API';
import { Tag } from 'components/ReferenceImageGenerator/molecules/ImageGeneratorStage';
import { SetManuals } from 'store/api/apiGenerated';

/* Load a set */
export interface SetLoadResponse {
  image_imported: number;
  json_file_length: number;
  code: string;
}

/* Device within a set */
export interface SetDeviceResponse {
  ref: string;
  code: string;
  display_code: string;
  description: string | null;
  part_image_file: string;
  num_parts: string;
  cannulated: boolean | null;
  debris_prone: boolean | null;
  qty: string;
  requires_inspection: boolean | null;
  additional_info: string | null;
  part_diagram: string | null;
  inspection_text: string | null;
  language_metadata: LanguageMetadata | null;
  test_metadata: TestMetadata | null;
  part_test_metadata: TestMetadata | null;
  prone_to_debris?: boolean;
  draft_exists: boolean | null;
  owned_by: string | null;
}

/* All devices within a set */
export interface SetDeviceResponses {
  [id: string]: SetDeviceResponse;
}

/* Tray within a set */
export interface SetTrayResponse {
  name: string;
  reference: string;
  image_file?: string;
  original_image_file?: string;
  reference_tags_metadata?: Tag[];
  non_standard: boolean;
  general_test?: boolean;
  parts: SetDeviceResponses;
  language_metadata: LanguageMetadata | null;
  additional_inspection_requirements?: string;
}

/* All trays within a set */
export interface SetTrayResponses {
  [tray: string]: SetTrayResponse;
}

/**
 * Set status of the draft set
 */
export enum DraftStatus {
  MODIFIED = 'MODIFIED',
  REVIEW = 'REVIEW',
  PENDING = 'PENDING',
  DRAFT = 'DRAFT',
  VALIDATED = 'VALIDATED',
  UNTOUCHED = 'UNTOUCHED',
  MERGED = 'MERGED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  ARCHIVED = 'ARCHIVED',
  TODO = 'TODO',
}

export enum SATOStatus {
  DRAFT = 'sato.draft',
  PENDING = 'sato.pending',
  ARCHIVED = 'sato.archived',
  REJECTED = 'sato.rejected',
  APPROVED = 'sato.approved',
  NOT_FOUND = 'sato.not_found',
}

export enum ModelStatus {
  LIVE = 'LIVE',
  NOT_LIVE = 'NOT_LIVE',
}

export enum SortStatus {
  NEWEST = 'Newest',
  OLDEST = 'Oldest',
}

/* A draft set */
export interface SetDraftResponse {
  region: string;
  code: string;
  display_code: string;
  name: string;
  jme_group: string;
  revision: string;
  savi_version: number;
  trays: SetTrayResponses;
  set_manuals: SetManuals;
  tenant: string;
  user_id: string;
  status: DraftStatus;
  owner_id: string;
  owner_email: string;
  sato_status: SATOStatus;
  model_status: ModelStatus;
  is_view_only: boolean;
  draft_exists: boolean;
  owned_by: string;
}

export interface UploadTrayReferenceImageForDraftResponse {
  image_path: string;
}
